import { useTranslation } from 'react-i18next'
import { Spinner } from '@/components/ui/spinner'

/** Right-panel document area while the file (or the viewer for it) is loading. */
export const PreviewLoading = () => (
  <div className="flex flex-1 items-center justify-center bg-muted">
    <Spinner />
  </div>
)

/** Right-panel document area when the file can't be shown: the header's "open in new tab" is the way out. */
export const PreviewUnavailable = () => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-1 items-center justify-center bg-muted p-6 text-center text-sm text-muted-foreground">
      {t('notebookPreviewUnavailable')}
    </div>
  )
}
